(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = 'google_analytics';

    if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.ga) return;

    // Google Analytics Globals
    window._gaq = window._gaq || [];
    window._gat = window._gat || [];
    window.GoogleAnalyticsObject = 'ga';
    
    window.ga = window.ga || function() {
        (window.ga.q = window.ga.q || []).push(arguments);
    };
    window.ga.l = (1 * new Date());


    function get_product_obj(data) {
        var product = {
            id: data.item.sku,
            name: data.item.sku + ": " + data.item.name,
            price: parseFloat(data.item.price).toFixed(2)
        };

        if (data.item.brand) {
            product.brand = data.item.brand;
        }

        if (data.item.collection_name) {
            product.category = data.item.shop_name + '/' + data.item.collection_name;
        } else {
            product.category = data.item.shop_name;
        }

        if (data.item.quantity) product.quantity = data.item.quantity;

        return product;
    }

    mL_events.subscribe('page', function(msg, data) {
        //console.log('pubsub ' + key + ' - ' + msg, data);

        var product_obj = (msg === 'page.item') ? get_product_obj(data) : false;

        var ga_obj = {};

        ga_obj.title = data.page.title;
        ga_obj.page = data.page.url_rel;

        // possibly redundant

        if (data.category) {
            ga_obj.dimension14 = data.category.name;
        }

        if (data.shop) {
            ga_obj.dimension13 = data.shop.name;
        }

        if (data.page) {
            ga_obj.dimension10 = data.page.type;
        }

        if (data.item) {
            ga_obj.dimension9 = data.item.sku;
        }

        if (data.cart) {
            ga_obj.dimension12 = data.cart.total;
        }

        if (product_obj) {
            ga('ec:addProduct', product_obj);
            ga('ec:setAction', 'detail');
            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { product_obj: product_obj, ga_obj: ga_obj });
        } else {
            if (mL_config.DEBUG) console.log(key + ' - ' + msg, ga_obj);
        }

        ga('send', 'pageview', ga_obj);


    });

    mL_events.subscribe('cart.remove_item', function(msg, data) {
        var ga_item = get_product_obj(data);

        ga('ec:addProduct', ga_item);
        ga('ec:setAction', 'remove');
        ga('send', 'event', 'UX', 'click', 'remove from cart');

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, ga_item);
    });

    mL_events.subscribe('cart.add_item', function(msg, data) {
        var ga_item = get_product_obj(data);

        ga('ec:addProduct', ga_item);
        ga('ec:setAction', 'add');
        ga('send', 'event', 'UX', 'click', 'add to cart');

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, ga_item);
    });

    mL_events.subscribe('order.proceed_to_checkout', function(msg, data) {

        function add_item(item) {
            var ga_item = get_product_obj({ item: item });
            ga('ec:addProduct', ga_item);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, ga_item);
        }

        for (var i = 0; i < data.items.length; i += 1) {
            add_item(data.items[i]);
        }

        ga('ec:setAction', 'checkout', { 'step': 1 });

        if (data.is_paypal) {
            ga('send', 'event', 'UX', 'click', 'proceed to paypal');
            if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - proceed to paypal - click event');
        } else {
            ga('send', 'event', 'UX', 'click', 'proceed to checkout');
            if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - proceed to checkout - click event');
        }

    });

    function sync_domains() {
        try {
            if (!mL.post_login_sync && mL.sync_it) {
                mL.sync_it();
            }
        } catch (er) {}
    }

    mL_events.subscribe('order.pageview', function(msg, data) {
        var _url = data.url;

        if (_url.indexOf('confirmation') !== -1) return;

        if (_url.indexOf('login-register') !== -1) {

            ga('ec:setAction', 'checkout', { 'step': 1 });

        } else if (_url.indexOf('opc') !== -1) {

            ga('ec:setAction', 'checkout', { 'step': 2 });

            sync_domains();

        } else if (_url.indexOf('review') !== -1) {

            ga('ec:setAction', 'checkout', { 'step': 3 });

        }

        ga('set', 'page', _url);
        ga('send', 'pageview');

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, _url);

    });

    mL_events.subscribe('order.event', function(msg, data) {
        var _event = data.event;

        if (_event && _event.category && _event.action) {
            ga('send', 'event', _event.category, _event.action, _event.label, parseFloat(_event.value) || 0);
        }

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, data);
    });

    mL_events.subscribe('order.confirmation', function(msg, data) {
        var _order = data.order;

        _order.items.forEach(function(item) {
            var ga_item = {
                id: item.sku,
                name: item.name,
                price: item.rate,
                quantity: item.quantity
            };
            if (item.category) ga_item.category = item.category;
            if (!_order.is_dev) ga('ec:addProduct', ga_item);
        });

        var ga_obj = {
            id: _order.order_id,
            revenue: _order.revenue,
            tax: _order.tax,
            shipping: _order.shipping,
            currency: _order.currency
        };

        if (_order.promocode && _order.promocode.isvalid) {
            ga_obj.coupon = _order.promocode.code;
        }

        if (!data.is_dev) {
            ga('ec:setAction', 'purchase', ga_obj);
            ga('set', 'page', _order.url);
            ga('send', 'pageview');
        }


        if (mL_config.DEBUG) console.log(key + ' - ' + msg, { ga_obj: ga_obj });
    });

    mL_events.subscribe('form', function(msg, obj) {
        if (!obj.data || obj.data.form) return;

        var form_obj = {
            hitType: 'event',
            eventCategory: 'Email Acquisition',
            eventAction: 'Submit Form',
            eventLabel: obj.data.form
        };

        ga('send', form_obj);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, form_obj);
    });


    mL.ga = mL.ga || {};

    mL.ga.init = function() {
        if (mL.ga.is_init || !mL.add_tracker || !window.ga) return false;

        ga('create', 'UA-3051893-1', 'auto', { 'allowLinker': true });
        ga('require', 'linker');
        ga('linker:autoLink', ['mlahart.com', 'gotovictorylane.com', 'netsuite.com', 'paypal.com', 'utexas-gifts.com'], false, true);
        ga('require', 'ec');

        ga(function(tracker) {
            var clientid = tracker.get('clientId');
            var linkers = tracker.get('linkerParam');

            mL.ga.clientid = clientid;
            mL.ga.linkers = linkers;
            mL.gaid = clientid;
            mL.linkparams = linkers;

            var obj = {};

            obj.dimension6 = clientid;
            obj.dimension7 = new Date().getTime().toString();

            ga('set', obj);

            if (!mL.is_checkout && !mL.is_app) ga('send', 'pageview');

        });


        mL.add_tracker('https://www.google-analytics.com/analytics.js', 'google');

        mL.ga.is_init = true;

        if (mL_config.DEBUG) console.log(key + ' - plugin loaded');
    };


}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));